import React from 'react';
import HistoryIcon from '@mui/icons-material/History';
import MenuBookIcon from '@mui/icons-material/MenuBook';

interface Props {
  open: boolean;
}

export const affinitiesIcon = ({ open }: Props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        fill={open ? 'white' : 'black'}
        fillOpacity={open ? '0.5' : '0.6'}
      />
      <path
        d="M13 4.069V2H11V4.069C9.24017 4.29335 7.60466 5.09574 6.3502 6.3502C5.09574 7.60466 4.29335 9.24017 4.069 11H2V13H4.069C4.29319 14.7599 5.09552 16.3955 6.35001 17.65C7.6045 18.9045 9.2401 19.7068 11 19.931V22H13V19.931C14.7599 19.7068 16.3955 18.9045 17.65 17.65C18.9045 16.3955 19.7068 14.7599 19.931 13H22V11H19.931C19.7066 9.24017 18.9043 7.60466 17.6498 6.3502C16.3953 5.09574 14.7598 4.29335 13 4.069ZM12 18C8.691 18 6 15.309 6 12C6 8.691 8.691 6 12 6C15.309 6 18 8.691 18 12C18 15.309 15.309 18 12 18Z"
        fill={open ? 'white' : 'black'}
        fillOpacity={open ? '0.5' : '0.6'}
      />
    </svg>
  );
};

export const historyIcon = ({ open }: Props) => {
  return (
    <HistoryIcon
      sx={{
        fontSize: '23.8px',
        color: open ? 'white' : 'black',
        opacity: open ? '.5' : '.6',
      }}
    />
  );
};

export const weeklyLogIcon = ({ open }: Props) => {
  return (
    <MenuBookIcon
      sx={{
        fontSize: '23.8px',
        color: open ? 'white' : 'black',
        opacity: open ? '.5' : '.6',
      }}
    />
  );
};

export const homeIcon = ({ open }: Props) => {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 20H16C16.5304 20 17.0391 19.7893 17.4142 19.4142C17.7893 19.0391 18 18.5304 18 18V9C18.0008 8.86839 17.9755 8.73793 17.9258 8.61609C17.876 8.49426 17.8027 8.38344 17.71 8.29L9.71 0.289999C9.52264 0.103748 9.26919 -0.000793457 9.005 -0.000793457C8.74081 -0.000793457 8.48736 0.103748 8.3 0.289999L0.3 8.29C0.205512 8.38261 0.130342 8.49306 0.0788453 8.61493C0.0273487 8.73681 0.00054925 8.86769 0 9V18C0 18.5304 0.210714 19.0391 0.585786 19.4142C0.960859 19.7893 1.46957 20 2 20ZM7 18V13H11V18H7ZM2 9.41L9 2.41L16 9.41V18H13V13C13 12.4696 12.7893 11.9609 12.4142 11.5858C12.0391 11.2107 11.5304 11 11 11H7C6.46957 11 5.96086 11.2107 5.58579 11.5858C5.21071 11.9609 5 12.4696 5 13V18H2V9.41Z"
        fill={open ? 'white' : 'black'}
        fillOpacity={open ? '0.5' : '0.6'}
      />
    </svg>
  );
};

export const linksIcon = ({ open }: Props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.22202 19.778C4.6859 20.2425 5.23699 20.6108 5.84364 20.8617C6.45029 21.1126 7.10054 21.2412 7.75702 21.24C8.41365 21.2411 9.06404 21.1126 9.67085 20.8617C10.2777 20.6108 10.8289 20.2425 11.293 19.778L14.121 16.949L12.707 15.535L9.87902 18.364C9.31549 18.925 8.55269 19.24 7.75752 19.24C6.96235 19.24 6.19955 18.925 5.63602 18.364C5.07453 17.8007 4.75923 17.0378 4.75923 16.2425C4.75923 15.4472 5.07453 14.6843 5.63602 14.121L8.46502 11.293L7.05102 9.879L4.22202 12.707C3.28583 13.6455 2.76007 14.9169 2.76007 16.2425C2.76007 17.5681 3.28583 18.8395 4.22202 19.778ZM19.778 11.293C20.7137 10.3543 21.2392 9.08292 21.2392 7.7575C21.2392 6.43208 20.7137 5.16072 19.778 4.222C18.8396 3.28581 17.5681 2.76005 16.2425 2.76005C14.9169 2.76005 13.6455 3.28581 12.707 4.222L9.87902 7.051L11.293 8.465L14.121 5.636C14.6846 5.07499 15.4474 4.76003 16.2425 4.76003C17.0377 4.76003 17.8005 5.07499 18.364 5.636C18.9255 6.19927 19.2408 6.96217 19.2408 7.7575C19.2408 8.55283 18.9255 9.31573 18.364 9.879L15.535 12.707L16.949 14.121L19.778 11.293Z"
        fill={open ? 'white' : 'black'}
        fillOpacity={open ? '0.5' : '0.6'}
      />
      <path
        d="M8.46401 16.95L7.04901 15.536L15.536 7.05L16.95 8.465L8.46401 16.95Z"
        fill={open ? 'white' : 'black'}
        fillOpacity={open ? '0.5' : '0.6'}
      />
    </svg>
  );
};

export const templatesIcon = ({ open }: Props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.903 8.586C19.8556 8.47747 19.7892 8.37825 19.707 8.293L13.707 2.293C13.6217 2.21078 13.5225 2.14441 13.414 2.097C13.384 2.083 13.352 2.075 13.32 2.064C13.2363 2.03553 13.1492 2.01837 13.061 2.013C13.04 2.011 13.021 2 13 2H6C4.897 2 4 2.897 4 4V20C4 21.103 4.897 22 6 22H18C19.103 22 20 21.103 20 20V9C20 8.979 19.989 8.96 19.987 8.938C19.9821 8.84972 19.9649 8.76255 19.936 8.679C19.926 8.647 19.917 8.616 19.903 8.586ZM16.586 8H14V5.414L16.586 8ZM6 20V4H12V9C12 9.26522 12.1054 9.51957 12.2929 9.70711C12.4804 9.89464 12.7348 10 13 10H18L18.002 20H6Z"
        fill={open ? 'white' : 'black'}
        fillOpacity={open ? '0.5' : '0.6'}
      />
      <path
        d="M8 12H16V14H8V12ZM8 16H16V18H8V16ZM8 8H10V10H8V8Z"
        fill={open ? 'white' : 'black'}
        fillOpacity={open ? '0.5' : '0.6'}
      />
    </svg>
  );
};

export const configurationIcon = ({ open }: Props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 16C14.206 16 16 14.206 16 12C16 9.794 14.206 8 12 8C9.794 8 8 9.794 8 12C8 14.206 9.794 16 12 16ZM12 10C13.084 10 14 10.916 14 12C14 13.084 13.084 14 12 14C10.916 14 10 13.084 10 12C10 10.916 10.916 10 12 10Z"
        fill={open ? 'white' : 'black'}
        fillOpacity={open ? '0.5' : '0.6'}
      />
      <path
        d="M2.84498 16.136L3.84498 17.866C4.37598 18.783 5.65398 19.127 6.57498 18.596L7.10398 18.29C7.68252 18.7451 8.32039 19.1192 8.99998 19.402V20C8.99998 21.103 9.89698 22 11 22H13C14.103 22 15 21.103 15 20V19.402C15.6793 19.1192 16.3172 18.7454 16.896 18.291L17.425 18.597C18.348 19.127 19.623 18.785 20.156 17.866L21.155 16.137C21.42 15.6777 21.4919 15.132 21.3548 14.6197C21.2177 14.1075 20.8829 13.6706 20.424 13.405L19.919 13.113C20.0263 12.3756 20.0263 11.6264 19.919 10.889L20.424 10.597C20.8827 10.3312 21.2174 9.89433 21.3544 9.38216C21.4914 8.86998 21.4197 8.32436 21.155 7.865L20.156 6.136C19.625 5.216 18.348 4.871 17.425 5.404L16.896 5.71C16.3174 5.25491 15.6796 4.8808 15 4.598V4C15 2.897 14.103 2 13 2H11C9.89698 2 8.99998 2.897 8.99998 4V4.598C8.32062 4.88084 7.6828 5.25459 7.10398 5.709L6.57498 5.403C5.65098 4.872 4.37498 5.216 3.84398 6.135L2.84498 7.864C2.57996 8.3233 2.50809 8.86901 2.64515 9.38126C2.78222 9.89352 3.117 10.3304 3.57598 10.596L4.08098 10.888C3.97321 11.6251 3.97321 12.3739 4.08098 13.111L3.57598 13.403C3.11714 13.669 2.78251 14.106 2.64547 14.6184C2.50843 15.1307 2.58018 15.6765 2.84498 16.136ZM6.17098 13.378C6.05806 12.9273 6.00064 12.4646 5.99998 12C5.99998 11.538 6.05798 11.074 6.16998 10.622C6.22272 10.4113 6.20537 10.1892 6.12056 9.98928C6.03576 9.78935 5.88811 9.6225 5.69998 9.514L4.57698 8.864L5.57498 7.135L6.71998 7.797C6.9067 7.90505 7.12344 7.94962 7.33765 7.92401C7.55185 7.89841 7.75198 7.80401 7.90798 7.655C8.5845 7.01156 9.40031 6.53281 10.292 6.256C10.4968 6.19347 10.6761 6.06683 10.8036 5.89473C10.931 5.72263 10.9999 5.51416 11 5.3V4H13V5.3C13.0001 5.51416 13.0689 5.72263 13.1964 5.89473C13.3238 6.06683 13.5032 6.19347 13.708 6.256C14.5995 6.53321 15.4152 7.0119 16.092 7.655C16.2481 7.80372 16.4482 7.89792 16.6624 7.92352C16.8765 7.94911 17.0932 7.90473 17.28 7.797L18.424 7.136L19.424 8.865L18.3 9.514C18.112 9.62262 17.9644 9.78948 17.8796 9.98938C17.7948 10.1893 17.7774 10.4113 17.83 10.622C17.942 11.074 18 11.538 18 12C18 12.461 17.942 12.925 17.829 13.378C17.7765 13.5888 17.7941 13.8109 17.8791 14.0108C17.964 14.2107 18.1118 14.3775 18.3 14.486L19.423 15.135L18.425 16.864L17.28 16.203C17.0933 16.0948 16.8765 16.0501 16.6623 16.0757C16.448 16.1013 16.2479 16.1958 16.092 16.345C15.4155 16.9884 14.5996 17.4672 13.708 17.744C13.5032 17.8065 13.3238 17.9332 13.1964 18.1053C13.0689 18.2774 13.0001 18.4858 13 18.7L13.002 20H11V18.7C10.9999 18.4858 10.931 18.2774 10.8036 18.1053C10.6761 17.9332 10.4968 17.8065 10.292 17.744C9.40048 17.4668 8.58476 16.9881 7.90798 16.345C7.75228 16.1954 7.55203 16.1007 7.33763 16.0753C7.12322 16.0498 6.90636 16.095 6.71998 16.204L5.57598 16.866L4.57598 15.137L5.69998 14.486C5.88817 14.3775 6.03593 14.2107 6.12091 14.0108C6.20588 13.8109 6.22346 13.5888 6.17098 13.378Z"
        fill={open ? 'white' : 'black'}
        fillOpacity={open ? '0.5' : '0.6'}
      />
    </svg>
  );
};
